// @ts-nocheck
import _ from "lodash";
import {
  DELETE_MESSAGE,
  EDIT_MESSAGE,
  NEW_MESSAGE_HANDLER,
  UPDATE_CHAT_ROOM_STATUS,
  UPDATE_MSG_STATUS
} from "../../customHooks/socketEvents/oneOnOneMessaging/constants";
import {
  apiRequest,
  emitOneToOneMessagesDelivered,
  emitSocketEvent
} from "../../services/apiService";
import { socket } from "../../services/socket.io/socket.io.config";
import { ALERT_DIALOG_LOADING } from "../constants/auth";
import {
  CHAT_ROOMS_FAILURE,
  CHAT_ROOMS_LOADING,
  CHAT_ROOMS_SUCCESS,
  FETCH_CHAT_ROOM_MESSAGES_FAILURE,
  FETCH_CHAT_ROOM_MESSAGES_LOADING,
  FETCH_CHAT_ROOM_MESSAGES_SUCCESS,
  SEND_NEW_MESSAGE_FAILURE,
  SEND_NEW_MESSAGE_LOADING,
  SEND_NEW_MESSAGE_SUCCESS,
  ADD_NEW_CHAT_ROOM_LOADING,
  ADD_NEW_CHAT_ROOM_SUCCESS,
  ADD_NEW_CHAT_ROOM_FAILURE,
  EDIT_NEW_MESSAGE_LOADING,
  EDIT_NEW_MESSAGE_SUCCESS,
  EDIT_NEW_MESSAGE_FAILURE,
  ON_EDIT_MESSAGE,
  DISABLE_CHAT_ROOM_LOADING,
  ON_NEW_MESSAGE_ONE_ON_ONE_CHAT,
  ON_MARK_MESSAGES_AS_READ
} from "../constants/oneononemessaging";

const createOneToOneChatRoom = ({
  payload,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    dispatch({
      type: SEND_NEW_MESSAGE_LOADING
    });

    dispatch({
      type: ADD_NEW_CHAT_ROOM_LOADING
    });

    const { response, error } = await apiRequest({
      method: "POST",
      url: "addOneToOneChats",
      data: payload,
      isToken: true
    });

    if (response) {
      dispatch({
        type: ADD_NEW_CHAT_ROOM_SUCCESS,
        payload: {
          newChatRoom: response?.data?.data
          // newChatRoomMessages: response?.data?.data?.messageData?.data
        }
      });

      dispatch({
        type: SEND_NEW_MESSAGE_SUCCESS
      });
      successCallback
        ? successCallback({
            res: response?.data?.data
          })
        : null;
    } else {
      dispatch({
        type: ADD_NEW_CHAT_ROOM_FAILURE
      });
      dispatch({
        type: SEND_NEW_MESSAGE_FAILURE
      });
      failureCallback
        ? failureCallback({
            error: response?.error
          })
        : null;
    }
  };
};

const updateOneToOneChatRoomStatusAction = ({ payload, chatId }) => {
  return async (dispatch, getState) => {
    dispatch({
      type: DISABLE_CHAT_ROOM_LOADING
    });

    const response = await emitSocketEvent({
      event: UPDATE_CHAT_ROOM_STATUS,
      payload: {
        ...payload,
        senderToken: getState()?.auth?.userToken,
        roomId: chatId
      }
    });
  };
};

const fetchOneOnOneChatRoomsForClient = ({
  payload,
  params,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    dispatch({
      type: CHAT_ROOMS_LOADING
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getOneToOneChatRooms`,
      params,
      isToken: true
    });

    if (response) {
      dispatch({
        type: CHAT_ROOMS_SUCCESS,
        payload: {
          chatRooms: response?.data?.data
        }
      });

      // do socket emit to for one to one messages get delivered
      emitOneToOneMessagesDelivered({
        roomIds: response?.data?.data?.map((c) => ({ id: c?._id }))
      });

      if (successCallback) {
        successCallback({
          res: response?.data
        });
      }
    } else {
      dispatch({
        type: CHAT_ROOMS_FAILURE
      });

      if (failureCallback) {
        failureCallback({
          error: error?.response
        });
      }
    }
  };
};

const fetchOneOnOneChatRoomMessagesForClient = ({
  payload,
  params,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_CHAT_ROOM_MESSAGES_LOADING
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getOneToOneMessages`,
      params,
      isToken: true
    });

    if (response) {
      dispatch({
        type: FETCH_CHAT_ROOM_MESSAGES_SUCCESS,
        payload: {
          chatRoomMessages: response?.data?.data
        }
      });

      if (successCallback) {
        successCallback({
          res: response?.data
        });
      }
    } else {
      dispatch({
        type: FETCH_CHAT_ROOM_MESSAGES_FAILURE
      });

      if (failureCallback) {
        failureCallback({
          error: error?.response
        });
      }
    }
  };
};

const sendOneOnOneChatMessageAction = ({
  payload,
  chatId,
  params,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: SEND_NEW_MESSAGE_LOADING
      });

      const response = await emitSocketEvent({
        event: NEW_MESSAGE_HANDLER,
        payload: {
          ...payload,
          senderToken: getState()?.auth?.userToken,
          roomId: chatId
        }
        // successCallback: ({ res }) => {
        //   console.log(">> delivered before", res);
        //   emitOneToOneMessagesDelivered({
        //     roomIds: _.isArray(res?.data)
        //       ? res?.data?.map((c) => ({ id: c?.chatId }))
        //       : [{ id: res?.data?.chatId }]
        //   });
        // }
      });

      if (response?.status === "ok") {
        dispatch({
          type: SEND_NEW_MESSAGE_SUCCESS,
          payload: {
            newMessage: response?.data?.data
          }
        });

        dispatch({
          type: ON_NEW_MESSAGE_ONE_ON_ONE_CHAT,
          payload: {
            newMessage: response?.data?.data
          }
        });

        if (successCallback) {
          successCallback({
            res: response?.data
          });
        }
      } else {
        dispatch({
          type: SEND_NEW_MESSAGE_FAILURE
        });

        if (failureCallback) {
          failureCallback({
            error: response?.error
          });
        }
      }

      // socket.emit(NEW_MESSAGE_HANDLER, {
      //   ...payload,
      //   senderToken: getState()?.auth?.userToken,
      //   roomId: chatId
      // }, (response) => {
      //   console.log(response, "sendOneOnOneChatMessageAction");

      //   if (response?.status === "ok") {
      //     console.log(response?.status === "ok", response?.data?.data, "sendOneOnOneChatMessageAction");
      //     dispatch({
      //       type: SEND_NEW_MESSAGE_SUCCESS,
      //       payload: {
      //         newMessage: response?.data?.data
      //       }
      //     });

      //     dispatch({
      //       type: ON_NEW_MESSAGE_ONE_ON_ONE_CHAT,
      //       payload: {
      //         newMessage: response?.data?.data
      //       }
      //     });

      //     if (successCallback) {
      //       successCallback({
      //         res: response?.data
      //       });
      //     }
      //   } else {
      //     dispatch({
      //       type: SEND_NEW_MESSAGE_FAILURE
      //     });

      //     if (failureCallback) {
      //       failureCallback({
      //         error: response?.error
      //       });
      //     }
      //   }
      // });
    } catch (err) {}
  };
};

const editMessageAction = ({
  messageId,
  roomId,
  payload,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    if (socket.connected) {
      // dispatch({
      //   type: ALERT_DIALOG_LOADING
      // });

      dispatch({
        type: EDIT_NEW_MESSAGE_LOADING
      });

      const response = await emitSocketEvent({
        event: EDIT_MESSAGE,
        payload: {
          roomId,
          messageId,
          ...(payload || {}),
          senderToken: getState()?.auth?.userToken
        }
      });

      if (response?.status === "ok") {
        dispatch({
          type: EDIT_NEW_MESSAGE_SUCCESS
        });

        dispatch({
          type: ON_EDIT_MESSAGE,
          payload: {
            editedMessage: response?.data
          }
        });
        successCallback({
          res: response?.data
        });
      } else {
        //
        dispatch({
          type: EDIT_NEW_MESSAGE_FAILURE
        });

        failureCallback?.({
          error: response?.error
        });
      }

      // socket.emit(EDIT_MESSAGE, {
      //   roomId,
      //   messageId,
      //   ...(payload || {}),
      //   senderToken: getState()?.auth?.userToken
      // }, (response) => {
      //   console.log(response, "editMessageEventHandler");
      //   if (response?.status === "ok") {
      //     dispatch({
      //       type: EDIT_NEW_MESSAGE_SUCCESS
      //     });

      //     dispatch({
      //       type: ON_EDIT_MESSAGE,
      //       payload: {
      //         editedMessage: response?.data
      //       }
      //     });
      //     successCallback({
      //       res: response?.data
      //     })
      //   } else {
      //     //
      //     dispatch({
      //       type: EDIT_NEW_MESSAGE_FAILURE
      //     });

      //     failureCallback?.({
      //       error: response?.error
      //     });
      //   }
      // })
    }
  };
};

const deleteMessageAction = ({ messageId, roomId, successCallback }) => {
  return async (dispatch, getState) => {
    dispatch({
      type: ALERT_DIALOG_LOADING
    });

    const response = await emitSocketEvent({
      event: DELETE_MESSAGE,
      payload: {
        roomId,
        messageId,
        senderToken: getState()?.auth?.userToken
      }
    });

    if (response?.status === "ok") {
      successCallback({
        res: response?.data?.data
      });
    } else {
      //
    }

    // socket.emit(DELETE_MESSAGE, {
    //   roomId,
    //   messageId,
    //   senderToken: getState()?.auth?.userToken
    // }, (response) => {
    //   console.log(response, "deleteMessageEventHandler");
    //   if (response?.status === "ok") {
    //     successCallback({
    //       res: response?.data?.data
    //     })
    //   } else {
    //     //
    //   }
    // })
  };
};

const fetchAdminsByClient = ({ params }) => {
  return async (dispatch) => {
    const { response, error } = await apiRequest({
      method: "GET",
      url: ``
    });
  };
};

const fetchOneOnOneChatRoomsForAdmin = ({
  payload,
  params,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    dispatch({
      type: CHAT_ROOMS_LOADING
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getOneToOneChatRooms`,
      params,
      isToken: true
    });

    if (response) {
      dispatch({
        type: CHAT_ROOMS_SUCCESS,
        payload: {
          chatRooms: response?.data?.data
        }
      });

      // do socket emit to for one to one messages get delivered
      emitOneToOneMessagesDelivered({
        roomIds: response?.data?.data?.map((c) => ({ id: c?._id }))
      });

      if (successCallback) {
        successCallback({
          res: response?.data
        });
      }
    } else {
      dispatch({
        type: CHAT_ROOMS_FAILURE
      });

      if (failureCallback) {
        failureCallback({
          error: error?.response
        });
      }
    }
  };
};

const fetchOneOnOneChatRoomMessagesForAdmin = ({
  payload,
  params,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_CHAT_ROOM_MESSAGES_LOADING
    });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getOneToOneMessages`,
      params,
      isToken: true
    });

    if (response) {
      dispatch({
        type: FETCH_CHAT_ROOM_MESSAGES_SUCCESS,
        payload: {
          chatRoomMessages: response?.data?.data
        }
      });

      if (successCallback) {
        successCallback({
          res: response?.data
        });
      }
    } else {
      dispatch({
        type: FETCH_CHAT_ROOM_MESSAGES_FAILURE
      });

      if (failureCallback) {
        failureCallback({
          error: error?.response
        });
      }
    }
  };
};

const fetchLatestMessageInChatRoomAction = ({
  params,
  successCallback,
  failureCallback
}) => {
  return async (dispatch) => {
    // dispatch({
    //   type: FETCH_CHAT_ROOM_MESSAGES_LOADING
    // });

    const { response, error } = await apiRequest({
      method: "GET",
      url: `getLastMessage`,
      params,
      isToken: true
    });

    if (response) {
      // dispatch({
      //   type: FETCH_CHATROOM_LATEST_MESSAGE_SUCCESS,
      //   payload: {
      //     chatRoomMessages: response?.data?.data
      //   }
      // });

      if (successCallback) {
        successCallback({
          res: response
        });
      }
    } else {
      // dispatch({
      //   type: FETCH_CHATROOM_LATEST_MESSAGE_FAILURE
      // });

      if (failureCallback) {
        failureCallback({
          error: error?.response
        });
      }
    }
  };
};

const markMessagesAsReadAction = ({
  payload,
  successCallback,
  failureCallback
}) => {
  return async (dispatch, getState) => {
    // Refetch sidebar/header unread badge counts after markAsRead (fix #291).
    // Without this, useFetchUnreadMsgChatRoomsCount only runs on the initial mount, so
    // the badge stays "stale" even though the BE correctly marks msgs as read.
    const refreshUnread = async () => {
      try {
        const { fetchUnreadMsgChatRoomsCountAction } = await import(
          "./groupMessagingActions"
        );
        dispatch(fetchUnreadMsgChatRoomsCountAction());
      } catch {
        /* noop */
      }
    };
    if (socket.connected) {
      // dispatch({
      //   type: ALERT_DIALOG_LOADING
      // });

      // dispatch({
      //   type: EDIT_NEW_MESSAGE_LOADING
      // });

      const response = await emitSocketEvent({
        event: UPDATE_MSG_STATUS,
        payload: {
          ...(payload || {}),
          token: getState()?.auth?.userToken
        }
        // successCallback: ({ res }) => {
        //   emitOneToOneMessagesDelivered({
        //     roomIds: res?.data?.map((c) => ({ id: c?._id })),
        //   });
        // },
      });

      if (response?.status === "ok") {
        // dispatch({
        //   type: EDIT_NEW_MESSAGE_SUCCESS
        // });

        // dispatch({
        //   type: ON_EDIT_MESSAGE,
        //   payload: {
        //     editedMessage: response?.data
        //   }
        // });
        dispatch({
          type: ON_MARK_MESSAGES_AS_READ,
          payload: {
            auth: getState()?.auth,
            chatRoomMessages: response?.data
          }
        });
        // refetch badge counts (sidebar + header) immediately after the BE confirms
        refreshUnread();
        successCallback
          ? successCallback({
              res: response?.data
            })
          : null;
      } else {
        //
        // dispatch({
        //   type: EDIT_NEW_MESSAGE_FAILURE
        // });

        failureCallback
          ? failureCallback?.({
              error: response?.error
            })
          : null;
      }

      // socket.emit(UPDATE_MSG_STATUS, {
      //   ...(payload || {}),
      //   token: getState()?.auth?.userToken
      // }, (response) => {
      //   console.log(response, "markMessagesAsReadAction");
      //   if (response?.status === "ok") {
      //     // dispatch({
      //     //   type: EDIT_NEW_MESSAGE_SUCCESS
      //     // });

      //     // dispatch({
      //     //   type: ON_EDIT_MESSAGE,
      //     //   payload: {
      //     //     editedMessage: response?.data
      //     //   }
      //     // });
      //     dispatch({
      //       type: ON_MARK_MESSAGES_AS_READ,
      //       payload: {
      //         auth: getState()?.auth,
      //         chatRoomMessages: response?.data
      //       }
      //     });
      //     successCallback ? successCallback({
      //       res: response?.data
      //     }) : null;
      //   } else {
      //     //
      //     // dispatch({
      //     //   type: EDIT_NEW_MESSAGE_FAILURE
      //     // });

      //     failureCallback ? failureCallback?.({
      //       error: response?.error
      //     }) : null;
      //   }
      // })
    }
  };
};

export {
  createOneToOneChatRoom,
  updateOneToOneChatRoomStatusAction,
  fetchOneOnOneChatRoomsForClient,
  fetchOneOnOneChatRoomMessagesForClient,
  sendOneOnOneChatMessageAction,
  editMessageAction,
  deleteMessageAction,
  fetchAdminsByClient,
  fetchOneOnOneChatRoomsForAdmin,
  fetchOneOnOneChatRoomMessagesForAdmin,
  fetchLatestMessageInChatRoomAction,
  markMessagesAsReadAction
};